import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import BugReportButton from "./components/BugReportButton/BugReportButton";
import UkraineStandImages from "./components/UkraineStandImages/UkraineStandImages";
import PopUp from "./components/PopUp/PopUp";
import NewsButton from "./components/NewsButton/NewsButton";
import SEO from "./components/SEO/SEO";


function App() {
    const [url, setUrl] = useState('');
    const [formats, setFormats] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [downloadLink, setDownloadLink] = useState('');
    const [vTitle, setTitle] = useState('');
    const [vFormat, setFormat] = useState('');
    const [progress, setProgress] = useState(0);
    const [isValid, setIsValid] = useState(true);

    const [showPopup, setShowPopup] = useState(localStorage.getItem('popRem'));


    //const popUpLocal = () => localStorage.getItem('popRem')  ? setShowPopup(false) : setShowPopup(true);

    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    const fetchVideoInfo = useCallback(async () => {
        try {
            const response = await axios.post(`${apiUrl}/info`, { url });
            setTitle(response.data.title);
            setFormats(response.data.formats);
            console.log('Available formats from API:', response.data.formats);
        } catch (error) {
            console.error('Error fetching video info:', error.response ? error.response.data.error : 'Error');
        }
    }, [apiUrl, url]);

    useEffect(() => {
        const fetchInfo = async () => {
            if (url && isValid) {
                await fetchVideoInfo();
            }
        };
        fetchInfo();
    }, [url, fetchVideoInfo, isValid]);

    const onDownloadProgress = (progressEvent) => {
        const total = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
        const loaded = progressEvent.loaded;
        const percentCompleted = Math.round((loaded * 100) / total);
        setProgress(percentCompleted);
    };

    const downloadMedia = async () => {
        setIsLoading(true);
        setDownloadLink('');
        setProgress(0);

        try {
            const selectedFormatData = formats.find(format => format.itag === selectedFormat);
            if (!selectedFormatData) {
                throw new Error('Selected format not found');
            }
            const formatExtension = selectedFormatData.container;

            console.log(`Downloading video in format: ${selectedFormatData.itag}, extension: ${formatExtension}`);

            const response = await axios.post(`${apiUrl}/download`, { url, format: selectedFormatData }, {
                responseType: 'blob',
                onDownloadProgress: onDownloadProgress
            });

            const blob = new Blob([response.data], { type: `video/${formatExtension}` });
            const downloadUrl = window.URL.createObjectURL(blob);

            setFormat(`.${formatExtension}`);
            setDownloadLink(downloadUrl);
            setIsLoading(false);
        } catch (error) {
            console.error('Error downloading video:', error.response ? error.response.data.error : error.message);
            setIsLoading(false);
        }
    };

    const handleUrlChange = (e) => {
        const value = e.target.value;
        const parts = value.split('&')[0];
        setUrl(parts);
        setIsValid(parts.includes('yout'));
    };

    useEffect(() => {
        if (downloadLink) {
            const anchor = document.createElement('a');
            anchor.href = downloadLink;
            anchor.download = `${vTitle}${vFormat}`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }, [downloadLink, vTitle, vFormat]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden">
            <SEO
                title="Download YouTube Videos in 4K 60fps HDR"
                description="Download YouTube videos in maximum quality (4K 60fps HDR) easily and quickly. Get the best video quality for your favorite content."
                keywords="YouTube download, 4K video, 60fps, HDR, high quality video download"
                canonical="https://youtobe-download.netlify.app/index.html"
            />
            <UkraineStandImages />
            {!showPopup && (
                <PopUp
                    title="Rules"
                    content="Downloading and using videos with"
                    onClose={() => setShowPopup(true)}
                />
            )}
            <div className="bubble"></div>
            <div className="bubble"></div>
            <div className="bubble"></div>
            <div className="bubble"></div>
            <div className="bubble"></div>
            <div className="bubble"></div>

            <div
                className="w-full max-w-lg bg-white bg-opacity-10 p-6 rounded-lg shadow-md relative z-10 backdrop-blur-md">
                <h1 className=" text-3xl font-bold tracking-tight text-white mb-6 text-center">
                    Download YouTube Video
                    <br />
                    <span className='title'> 4k 60fps HDR</span>
                </h1>
                <div className="mb-4">
                    <input
                        className={`w-full px-4 py-2 text-lg text-gray-900 bg-gray-100 rounded-md border-2 focus:outline-none ${isValid ? 'border-transparent focus:border-blue-500' : 'border-red-500'}`}
                        type="text"
                        value={url}
                        onChange={handleUrlChange}
                        placeholder="Enter YouTube URL"
                    />
                    {!isValid && <p className="text-red-500 mt-2">URL must contain the word "youtube".</p>}
                </div>

                {formats.length > 0 && (
                    <div className="mb-4">
                        <select
                            className="w-full px-4 py-2 text-lg text-gray-900 bg-gray-100 rounded-md border-2 border-transparent focus:outline-none focus:border-blue-500"
                            value={selectedFormat}
                            onChange={(e) => setSelectedFormat(parseInt(e.target.value))}
                        >
                            <option value="">Select Quality</option>
                            {formats.map((format) => (
                                <option key={format.itag} value={format.itag}>
                                    {format.qualityLabel} ({format.container})
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                <button
                    className={`w-full px-4 py-2 text-lg text-white rounded-md ${isLoading || !selectedFormat || !isValid ? 'bg-gray-600 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                    onClick={downloadMedia}
                    disabled={isLoading || !selectedFormat || !isValid}
                >
                    {isLoading ? 'Downloading...' : 'Download'}
                </button>

                {isLoading && (
                    <div className="w-full bg-gray-700 rounded-full h-2.5 mt-4 mb-5">
                        <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
                        <span className="block text-white text-center mt-2">Progress: {progress}%</span>
                    </div>
                )}

                {downloadLink && (
                    <div className="mt-4">
                        <a
                            className="block text-center text-blue-500 hover:underline"
                            href={downloadLink}
                            download={`${vTitle}${vFormat}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Download File
                        </a>
                    </div>
                )}
            </div>

            <div className={'button-section'}>
                <NewsButton />
                <BugReportButton />
            </div>

        </div>
    );
}

export default App;
